document.addEventListener("DOMContentLoaded", function () {
  document.body.addEventListener("click", function (event) {
    const button = event.target.closest(".js-product__photo-popup");

    if (button) {
      const imageWrap = button.closest(".image-wrap");
      const img = imageWrap.querySelector("img[src], img[data-photoswipe-src]");
      const targetSrc = img?.getAttribute("src") || img?.getAttribute("data-photoswipe-src");

      const imageIndex = parseInt(button.getAttribute("data-image-index"), 10);

      // Only open the popup — content should already be set elsewhere
      window.ProductPopup.open();

      // Scroll to the clicked image
      const light_box_main_images = document.querySelector(".light-box-main-images");
      const light_box_thumb_images = document.querySelectorAll(".image-popup-indicator img");
      const targetMainImage = Array.from(
        light_box_main_images.querySelectorAll("div[data-image-index]")
      ).find(el => Number(el.getAttribute("data-image-index")) === imageIndex);

      const targetThumbImage = light_box_thumb_images[imageIndex];

      if (targetThumbImage) {
        targetThumbImage.classList.add("active");
        setTimeout(() => {
          targetThumbImage.scrollIntoView();
        }, 0);
      }
      if (targetMainImage) {
        setTimeout(() => {
          targetMainImage.scrollIntoView({
            block: "start",
            behavior: "auto"
          });
        }, 0);
      }
      
    }
  });
});

window.ProductPopup = (function () {
  const overlay = document.querySelector(".custom_product_image_popup_wrapp");
  const contentContainer = overlay.querySelector(".lightbox-slider-container");
  const closeButton = overlay.querySelector("button.close");

  let contentHTML = ""; // Store the content separately

  function setContent(options = {}) {
    const { imageUrls, video } = options;
    
    const mainImageUrls = imageUrls.map((url) => {
      return url.replace(/(width=)(\d+)/, "$11600");
    });

    const thumbsUrls = imageUrls.map((url) => {
      return url.replace(/(width=)(\d+)/, "$1100");
    });

    const thumbsHTML = thumbsUrls.map((url) => {
      return `<img src="${url}" />`;
    }).join("");

    const mainHTML = mainImageUrls.map((url, index) => {
      return `
        <div data-image-index="${index}">
          ${index === 1 && video != null ? 
            `
            <div class="product__video-wrapper">
              <is-land on:visible="" ready="">
                <div class="video-media aspect-ratio--16-9" data-background="false">
                  <video-media loaded="">
                    <video 
                      playsinline="true" 
                      controls="controls" 
                      preload="metadata" 
                      poster="${video.poster}">
                      <source src="${video.videoSrc}" type="video/mp4">
                      <img src="${video.img}" alt="Video thumbnail">
                    </video>
                    <div class="video-play-button-area">
                      <button class="video-play-button" aria-label="Play Video">
                        <span class="icon">
                          <svg xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false" role="presentation" class="icon icon-play" viewbox="18.24 17.35 24.52 28.3" fill="currentColor" width="20" height="20"><path d="M22.1 19.151v25.5l20.4-13.489z" /></svg>
                        </span>
                      </button>
                    </div>
                  </video-media>
                </div>
              </is-land>
            </div>
            `
            :
            `<img src="${url}" alt="Product image">`
          }
          <div style="display: flex; justify-content: end;">
            <p style="background: black; padding: 5px 10px; color: white;">
              ${index === 1 && video != null ? 'Video' : 'Image'}
              ${index + 1} of ${imageUrls.length}
            </p>
          </div>
        </div>
      `;
    }).join("");

    // Build the HTML and store it
    contentHTML = `
      <div class="image-popup-indicator">${thumbsHTML}</div>
      <div class="light-box-main-images">${mainHTML}</div>
    `;
  }

  function open() {
    // Inject stored content before opening
    contentContainer.innerHTML = contentHTML;

    overlay.classList.remove("close");
    overlay.classList.add("open");
    document.body.classList.add("Popup_open");

    // Re-bind image click events after content injection
    const imagePopupIndicator = overlay.querySelector(".image-popup-indicator");
    const light_box_main_images = overlay.querySelector(".light-box-main-images");

    addImageEvents(imagePopupIndicator, light_box_main_images);
  }

  function addImageEvents(imagePopupIndicator, light_box_main_images) {
    const indicatorImages = Array.from(
      imagePopupIndicator.querySelectorAll("img")
    );
    const mainImages = Array.from(
      light_box_main_images.querySelectorAll("div[data-image-index]")
    );
    let currentIndex = 0;
    let isProgrammaticScroll = false;

    const isMobile = window.innerWidth <= 768;

    function updateThumbnail(index = currentIndex) {
      indicatorImages.forEach((i) => i.classList.remove("active"));
      indicatorImages[index].classList.add("active");

      if (isMobile) {
        const thumb = indicatorImages[index];
        const thumbRect = thumb.getBoundingClientRect();
        const containerRect = imagePopupIndicator.getBoundingClientRect();

        if (
          thumbRect.left < containerRect.left ||
          thumbRect.right > containerRect.right
        ) {
          requestAnimationFrame(() => {
            thumb.scrollIntoView({
              block: "nearest",
              inline: "center",
              behavior: "smooth",
            });
          });
        }
      }
    }

    // MOBILE: scroll-based detection
    if (isMobile) {
      light_box_main_images.addEventListener("scroll", () => {
        if (isProgrammaticScroll) return;

        const containerScrollLeft = light_box_main_images.scrollLeft;
        const containerCenter =
          containerScrollLeft + light_box_main_images.offsetWidth / 2;

        let closestIndex = currentIndex;
        let minDistance = Infinity;

        mainImages.forEach((img, index) => {
          const imgCenter = img.offsetLeft + img.offsetWidth / 2;
          const distance = Math.abs(containerCenter - imgCenter);
          if (distance < minDistance) {
            minDistance = distance;
            closestIndex = index;
          }
        });

        if (closestIndex !== currentIndex) {

          // 🔥 STOP VIDEO WHEN SLIDE CHANGES
          const currentSlide = mainImages[currentIndex];
          const video = currentSlide.querySelector("video");
          if (video) {
            video.pause();
          }

          currentIndex = closestIndex;
          updateThumbnail();
        }
      });
    } else {
      // DESKTOP: use IntersectionObserver with multiple thresholds
      const observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (entry.isIntersecting) {
              const index = parseInt(entry.target.getAttribute("data-image-index"), 10);
              console.log(index);
              
              if (index !== currentIndex) {
                currentIndex = index;
                updateThumbnail();
              }
            }
          });
        },
        {
          threshold: [0.6]
        }
      );
      mainImages.forEach((img) => observer.observe(img));
    }

    // Thumbnail click handler (both mobile & desktop)
    indicatorImages.forEach((thumb, index) => {
      thumb.addEventListener("click", () => {

        // 🔥 STOP VIDEO ON CURRENT SLIDE BEFORE MOVING
        const currentSlide = mainImages[currentIndex];
        const video = currentSlide.querySelector("video");
        if (video) {
          video.pause();
        }

        currentIndex = index;
        updateThumbnail();

        isProgrammaticScroll = true;
        mainImages[index].scrollIntoView({ behavior: "smooth", block: "start" });

        setTimeout(() => {
          isProgrammaticScroll = false;
        }, 400);
      });
    });

    // Initialize
    updateThumbnail();
  }

  function close() {
    overlay.classList.remove("open");
    overlay.classList.add("close");
    document.body.classList.remove("Popup_open");
  }

  closeButton.addEventListener("click", close);

  overlay.addEventListener("click", function (e) {
    if (e.target === overlay) close();
  });

  return {
    setContent,
    open,
    close,
  };
})();
